module.exports = "/packs/nagoya_design_banner-172841f463a2c0effab57d1a8261e495.jpg";